import { useGoogleAuthStatus } from '../lib/queries.js';

// Logo oficial do Google (multicolor) em SVG.
function GoogleLogo() {
  return (
    <svg className="h-5 w-5" viewBox="0 0 24 24" aria-hidden="true">
      <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1Z" />
      <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84A11 11 0 0 0 12 23Z" />
      <path fill="#FBBC05" d="M5.84 14.1a6.6 6.6 0 0 1 0-4.2V7.06H2.18a11 11 0 0 0 0 9.88l3.66-2.84Z" />
      <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.06l3.66 2.84C6.71 7.3 9.14 5.38 12 5.38Z" />
    </svg>
  );
}

// Botão "Continuar com Google" — só renderiza se a integração estiver configurada
// no admin (GET /auth/google/status). Navega para a rota OAuth da API (/api proxy).
export function GoogleSignInButton() {
  const status = useGoogleAuthStatus();
  if (!status.data?.enabled) return null;

  return (
    <div className="mt-5">
      <div className="mb-4 flex items-center gap-3 text-xs text-zinc-600">
        <span className="h-px flex-1 bg-zinc-800" />
        ou
        <span className="h-px flex-1 bg-zinc-800" />
      </div>
      <button
        type="button"
        onClick={() => { window.location.href = '/api/auth/google'; }}
        className="flex w-full items-center justify-center gap-3 rounded-lg border border-zinc-700 bg-zinc-900/80 py-2.5 font-medium text-zinc-100 transition-colors hover:bg-zinc-800 active:scale-[0.99]"
      >
        <GoogleLogo />
        Continuar com Google
      </button>
      <p className="mt-3 text-center text-xs text-zinc-600">
        Ao continuar com Google, você concorda com os Termos e a Política de Privacidade.
      </p>
    </div>
  );
}
